export default {"src":"/_next/static/media/ic-file-plus.9207a197.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};